import { sortBy } from 'lodash';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import SizeGuideModal from '~/components/Modals/SizeGuideModal';
import ColorSelect from '~/components/ProductVariants/ColorSelect';
import ImageSelect from '~/components/ProductVariants/ImageSelect';
import SingleSelect from '~/components/ProductVariants/SingleSelect';
import SwatchSelect from '~/components/ProductVariants/SwatchSelect';
import { Product, ProductConfigurableOption, ProductVariant } from '~/services/product';

type Props = {
    defaultConfig: any;
    loading?: boolean;
    variant: ProductVariant;
    onChangeConfig: (variant: ProductVariant) => void;
    product: Product;
};

const ProductVariants = ({ product, defaultConfig, loading, variant, onChangeConfig }: Props) => {
    const swatch_attribute = product?.swatch_attribute;
    const findVariantByAttributes = (attributes: any) => {
        const result = product?.variants?.find((variant) => {
            return attributes?.every((attr: any) => {
                const variantAttribute = variant.attributes?.find((vAttr) => vAttr.code === attr.code);
                return variantAttribute && variantAttribute.value_index === attr.value_index;
            });
        });

        return result;
    };

    const renderVariants = (config: Partial<ProductConfigurableOption>, indexConfig: number) => {
        if (!config) {
            return null;
        }

        const variantConfig: any = variant?.attributes?.find((va) => va.code === config.attribute_code);
        const options: any = config.values?.map((c) => {
            const newAttr = variant?.attributes?.map((currentAttr: any) => {
                if (currentAttr.code === config.attribute_code) {
                    return {
                        ...c,
                        code: config.attribute_code
                    };
                }
                return {
                    ...currentAttr
                };
            });
            const variantExits = findVariantByAttributes(newAttr);

            return {
                ...c,
                disabled: !variantExits && config.attribute_code !== 'category_master'
            };
        });
        if (config.attribute_code === 'category_master' && options.length < 2) {
            return;
        }
        if (config.attribute_code === swatch_attribute) {
            const newOptions: any = options.map((option: any) => {
                const listImage = product.variants?.filter(
                    (v) =>
                        v.attributes.findIndex(
                            (attr: any) =>
                                attr.code === config.attribute_code && option.value_index === attr.value_index
                        ) > -1
                );
                return {
                    swatchObject: listImage?.[0],
                    ...option
                };
            });

            return (
                <SwatchSelect
                    key={config.id}
                    title={config.label}
                    options={newOptions}
                    value={variantConfig?.value_index}
                    onChange={(selectedItem) => {
                        handleChangeConfig(selectedItem.value_index, config.attribute_code);
                    }}
                />
            );
        }

        if (config.attribute_code === 'color') {
            return (
                <ColorSelect
                    key={config.id}
                    title={config.label}
                    options={options}
                    value={variantConfig?.value_index}
                    onChange={(selectedItem) => {
                        handleChangeConfig(selectedItem.value_index, config.attribute_code);
                    }}
                />
            );
        }
        // if attr là swaps hình sẽ show ra dạng hiện hình.
        //  => dựa vào variants để lấy ra
        if (config.attribute_code?.includes('IMAGE')) {
            return (
                <ImageSelect
                    key={config.id}
                    title={config.label}
                    options={options}
                    value={variantConfig?.value_index}
                    onChange={(selectedItem) => {
                        handleChangeConfig(selectedItem.value_index, config.attribute_code);
                    }}
                />
            );
        }

        return (
            <>
                {
                    <SingleSelect
                        key={config.id}
                        attribute_code={config.attribute_code}
                        title={config.label}
                        options={options}
                        value={variantConfig?.value_index}
                        onChange={(selectedItem) => {
                            handleChangeConfig(selectedItem.value_index, config.attribute_code);
                        }}
                        extra={
                            config.attribute_code === 'size' ? (
                                <>
                                    <SizeGuideModal key={config.id + 'modal'} sku={product?.sku} />
                                </>
                            ) : (
                                ''
                            )
                        }
                    />
                }
            </>
        );
    };

    const handleChangeConfig = (valueIndex: number, code?: string) => {
        if (!code) {
            return;
        }
        const cloneVariantAttributes = variant.attributes?.map((attr) => {
            if (attr.code === code) {
                return { ...attr, value_index: valueIndex };
            }

            return attr;
        });
        const foundVariant = findVariantByAttributes(cloneVariantAttributes);

        if (foundVariant && foundVariant.product.id !== variant.product.id) {
            onChangeConfig?.(foundVariant);
        } else if (!foundVariant) {
            const lisVariantFirstAttr =
                product?.variants?.filter((variant) => {
                    return variant.attributes?.findIndex((i) => i.value_index === valueIndex) > -1;
                }) || [];
            if (!!lisVariantFirstAttr.length) {
                const first = lisVariantFirstAttr[0];
                onChangeConfig?.(first);
            }
        }
    };
    if (!!loading) {
        return [1, 2]?.map((n: number) => (
            <div key={n} className="flex flex-col ">
                <Skeleton height={16} className="aspect-square w-20"></Skeleton>
                <div className="flex gap-2">
                    {Array.from({ length: 6 }, (v: any, index: number) => (
                        <Skeleton key={index} width={120} height={40} className="aspect-square"></Skeleton>
                    ))}
                </div>
            </div>
        ));
    }
    return sortBy(defaultConfig, (cofig) => cofig.position).map((cfg, index: number) => renderVariants(cfg, index));
};

export default ProductVariants;
